// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3LyH4","dragIcon":"SortableItem_dragIcon__9i0oh","disabled":"SortableItem_disabled__2PI9R"};